import styled from 'styled-components'

export const ContainerColumn = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: 'center';
  align-items: 'center';
  gap: 10px;
  padding-top: 35px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const BoxOnContainerDetectionType = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 450px;
  height: 640px;

  @media (max-height: 990px) {
    height: 600px;
  }

  @media (max-height: 960px) {
    height: 550px;
  }

  @media (max-height: 750px) {
    height: 0px;
    min-height: 360px;
  }
`
